// extracted by mini-css-extract-plugin
export default {"wrapper":"vA-z","viewport":"wA-z","container":"xA-z","slide":"yA-z"};